module.exports = __webpack_public_path__ + "static/img/ptd2.62f28b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ptd/ptd2.png
// module id = 775
// module chunks = 0